// App-Create über VUE
import { createApp } from 'vue'

// ESM: Bootstrap 5 (bootstrap 4 wird aktuell noch verwendet)
// import 'bootstrap/dist/css/bootstrap.css';
// import 'bootstrap';

// ESM: Fancybox 6
import { Fancybox } from "@fancyapps/ui"
import "@fancyapps/ui/dist/fancybox/fancybox.css"

// ESM: toastr
// import 'toastr/build/toastr.min.css';
// import 'toastr';

// ESM: Datatables (mit Bootstrap5)
// import 'datatables.net-bs5/css/dataTables.bootstrap5.css';
// import DataTable from 'datatables.net-bs5';

/**
 * Nur CSS (Javascripts werden statisch kopiert und einzeln per <script> eingefügt)
 */
// Bootstrap
import 'bootstrap/dist/css/bootstrap.css';

// Bootstrap-Icons
import 'bootstrap-icons/font/bootstrap-icons.css';

// cookieconsent
import 'cookieconsent/build/cookieconsent.min.css';

// datatables.net-dt
import 'datatables.net-dt/css/dataTables.dataTables.css';

// fonts
import '@fontsource/open-sans-condensed/300.css';
import '@fontsource/open-sans-condensed/700.css';
import '@fontsource/open-sans/300.css';
import '@fontsource/open-sans/400.css';
import '@fontsource/open-sans/600.css';
import '@fontsource/open-sans/700.css';
import '@fontsource/open-sans/400-italic.css';

// font-awesome
import '@fortawesome/fontawesome-free/css/all.css'

// hover.css
import 'hover.css/css/hover.css'

// Eigene Stylesheets
import './styles1.css';
import './styles2.css';

// SpeditionOverview
// import SpeditionOverview from './src/components/spedition/SpeditionOverview.vue'

// DOM-Loaded
document.addEventListener('DOMContentLoaded', function ()
{
	// let el = null;

	// spedition_overview datatable
	// createApp(SpeditionOverview).mount('#spedition_overview')

	/**
	 * Fancybox
	 */
	Fancybox.bind('[data-fancybox]', {
		// optional config
	});

})